import React from "react";
import  { useState, useEffect } from 'react';
import './classes/RugbyEducationProgram.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const RugbyEducationProgram = () => {

    // const navigate = useNavigate();
   const app_url = configData.APP_URL;
   const [isLoading, setIsLoading] = useState(true);
   const [mentors, setMentors] = useState([]);
   const [courseTopics, setCourseTopics] = useState([]);
   const [testimonialsData, setTestimonialsData] = useState([]);

    useEffect(() => {
        const mentors = [
             {
                name: "Mick Hogan",
                image: "/basic/web/images/scout/mickhoganew.jpg",               
               
             },         
            
        ];
        setMentors(mentors);

        const courseTopics = [
            "Recruiting, player evaluation, player ratings and in-depth player analysis",
            "Rugby Union Scouting",
            "Rugby League Scouting",
            "Methods of ranking high-school and university prospects",
            "The making of a proper rugby scouting report",
            "The language and history of rugby as it pertains to different parts of the world",
            "Concise evaluation techniques and terminology",
            "New age scouting vs. Traditional methods",
            ];
        setCourseTopics(courseTopics);

           const initialTestimonials  = [
        {
            id: 1,
            name: "Mike Ablett",
            title: "Austin Herd Chief Marketing Officer",
            image:
            "/basic/web/images/scout/picture-2556-1454348562.jpg",
            link: "/testimonial/mike-ablett",
            body: `The Rugby Business Management Course is a must for any one who is involved in Rugby or is looking at pursuing a career in Rugby Administration. The personal attention and weekly audio chats were great and it created an open forum to compare, debate and analyze the game we love.  `
        }
        ];
   setTestimonialsData(initialTestimonials);

    },[]);

    useEffect(() => {
        Promise.all([
            
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    // const handleClick = (continent) => {
    //     navigate('/continents/'+continent+'/scouts');
    // };
      
    
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" className="rugby-education-progarm-main">
                <Helmet><title>Rugby Scout Education</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                   <div className="rugby-education-progarm-container">
                    <div className="scouting-mentors">                        
                            <h1>SMWW Rugby Education Program</h1>
                            <p>SMWW Rugby Scouts have been trained and mentored by some of the best in the industry. SMWW Rugby Scouts have completed a rigorous eight week training program and instructed by Abe Kerr, Tri Line Sports Founder. SMWW Rugby Scouts are listed here with scouting report samples. Please contact them and arrange a complimentary scouting report for your program, be it at the high school, university, or professional level.</p>
                            <h2>SMWW Rugby Scouting Mentors:</h2>
                             {mentors.map((mentor,index) => (
                                <div className="scout-mentors" key={mentor.name} style={{ marginBottom: "1.5rem", overflow: "auto" }}>
                                <img
                                    src={mentor.image}
                                    alt={mentor.name}
                                    className={`mentor-image mentor-image-${index}`}
                                />
                                <p>
                                    <strong>{mentor.name}</strong>  has been involved in Rugby League & Rugby Union for his entire 22-year career. A graduate of the Sports Studies degree course at Northumbria University he has worked for both governing bodies (Rugby Football League & Rugby Football Union) as well as CEO/Managing Director for top flight rugby clubs Wigan Warriors, Sale Sharks and Newcastle Falcons. Mick has also set up three charitable rugby foundations as well as serving on the board of Premiership Rugby on two separate occasions.
                                </p>
                                <p>Mick originally started his career as the North East Rugby League Development Officer. After this role he joined Gateshead Thunder as Community Marketing Manager for their one year in Super League. In 2000 he crossed the River Tyne to join rugby union club Newcastle Falcons as Head of Marketing for two seasons before moving to Premiership Rugby as Head of Community Development.</p>
                                <p>Whilst at Premiership Rugby Mick worked with all twelve Premiership clubs on their community marketing programs and attracted support from Powergen for the inaugural National Community Rugby Programme. He also worked on the first two Premiership Finals at Twickenham as well as personally developing the London Double Header concept – where over 70,000 fans annually attend the season opening games in London.</p>
                                <p>In 2004 Mick returned to Newcastle Falcons as Commercial Director where over the next four seasons the club established attendance records and league high levels for both sponsorship and retail sales. In 2008 a move to rugby league's Wigan Warriors as CEO saw two seasons that culminated in the club's first Grand Final success in twelve years. Mick then spent two years as CEO of Sale Sharks and led the negotiations for the club's move from Stockport to a new purpose built rugby stadium in Salford. At both Wigan and Sale Mick set up and chaired both clubs' charitable Community Rugby Foundations</p>
                                <p>In 2012 Mick set up his sports consultancy – MMG Sports Ltd. He worked for two and a half years for England 2015, the organizing body for the 2015 Rugby World Cup which will be staged in twelve English cities as well as Cardiff. The work for England 2015 saw Mick head up City Delivery and he managed the process that identified and selected the thirteen host cities for the Tournament.</p>
                                <p>Now back at Newcastle for a third spell Mick is currently Managing Director at Newcastle Falcons as well as Chairman of the Falcons Community Foundation. The club have also acquired Newcastle Thunder Rugby League and will deliver the official Rugby World Cup Fanzone on behalf of the City Council.</p>
                                </div>
                            ))}
                            <h2>SMWW Rugby Scouts have successfully completed 8 weeks of training including:</h2>
                                <ul>
                                    {courseTopics.map((topic, index) => (
                                    <li key={index}>{topic}</li>
                                    ))}
                                </ul>
                               <div style={{ clear: "both", textAlign: "center", marginBottom: "10px" }}>
                                <a className="reddbtnn" href={`https://${configData.RSMWW_DOMAIN}/application`}>
                                Apply Today
                                </a>
                               </div>
                            <p>
                                <p>&nbsp;</p>
                            <span><strong><a href="/scout-sports/rugby">Click here</a>   to search for a SMWW Rugby Scout by Area.   </strong><br/>
                            SMWW Scouts will do a complimentary scouting report to your specifications to prove they are an expert.</span></p>
                            <p><strong><em>SMWW Scouts will be an exceptional resource to save you time and money in your program!</em></strong></p>
                    </div>
                  
                    </div>
                </div>
                <div className="right rugby-education-right">
                     <div id="block-views-testimonials-block" className="block block-views">
                    <h2>Testimonials:</h2>

                  <div className="">
                        <div className="view view-testimonials">
                        <div className="">
                            <div className="testimonial-wrapper">
                            <ul>
                                {testimonialsData.map((testimonial) => (
                                <li
                                    key={testimonial.id}
                                    className="views-row"
                                >
                                    <div className="desktop_testimonials">
                                    <div className="views-field views-field-field-image">
                                        <div className="field-content">
                                        <img
                                            className="lazyloaded"
                                            src={testimonial.image}
                                            alt={testimonial.name}
                                            style={{ width: "100px", height: "100px" }}
                                        />
                                        </div>
                                    </div>

                                    <div className="views-field views-field-title title">
                                        <span className="field-content">
                                        <a href={testimonial.link}>{testimonial.name}</a>
                                        </span>
                                    </div>

                                    <div className="views-field views-field-field-author-title text">
                                        <div className="field-content">{testimonial.title}</div>
                                    </div>

                                    <div className="views-field views-field-body">
                                        <div className="field-content">
                                        <p>{testimonial.body}</p>
                                        </div>
                                    </div>
                                    </div>

                                   

                                    <div className="mobile_testimonials">
                                    <div className="views-field views-field-field-image">
                                        <div className="field-content">
                                        <img
                                            className="lazyload testimonial_mobile_image"
                                            src={testimonial.image}
                                            alt={testimonial.name}
                                        />
                                        </div>
                                    </div>

                                    <div className="testimonial_wrapper_mobile">
                                        <div className="testimonial_left_content">
                                        <div className="testimonial_title">
                                            <a href={testimonial.link}>{testimonial.name}</a>
                                        </div>
                                        <br />
                                        <div className="testimonial_tag_line">
                                            {testimonial.title}
                                        </div>
                                        </div>
                                        <div className="testimonial_right_content">
                                        <div className="testimonial_body_content">
                                            <p>{testimonial.body}</p>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                </li>
                                ))}
                              
                            </ul>
                            </div>
                        </div>
                        </div>
                    </div>
                   

                    </div>
                      {/* {
                        (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                        userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                        userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
                            &&  */}
                            <SalespersonSidebar /> 
                        {/* }  */}
                </div>
            </div>
        )}
        </>
    );
};
export default RugbyEducationProgram;